import React, { useState, useEffect, useContext } from 'react'
import { MdEmail } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import logo from '../../assets/biztrade_logo/logo.png'
import img from '../../assets/forgot_password/Login-amico.png'
import { Auth } from '../../contexts/allContext'
import { apiV1 } from '../../utils/api'
import classes from './ForgotPassword.module.css'

const ForgotPassword = () => {
    const navigate = useNavigate()
    const [email, setEmail] = useState('')
    const [otp, setOtp] = useState('')
    const [timer, setTimer] = useState(300)
    const [isOtpSent, setIsOtpSent] = useState(false)
    const { stateAuth, dispatchAuth } = useContext(Auth)

    // Countdown Timer
    useEffect(() => {
        let interval
        if (isOtpSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1)
            }, 1000)
        }
        return () => clearInterval(interval)
    }, [isOtpSent, timer])

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60)
        const secs = seconds % 60
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    }

    const sendOtp = async () => {
        const url = `${apiV1}/codes/reset?email=${encodeURIComponent(email)}`

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            })

            const data = await response.json()

            if (response.ok) {
                setIsOtpSent(true)
                setTimer(300) // reset timer
            } else {
                toast.error(data?.message || 'Invalid email address.', {
                    position: 'top-center',
                })
            }
        } catch (error) {
            console.error('Error:', error)
            toast.error('Network error. Please try again later.', {
                position: 'top-center',
            })
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        sendOtp()
    }

    const handleOtpSubmit = async (e) => {
        e.preventDefault()

        const url = `${apiV1}/codes/reset/verification`
        const details = {
            email: email,
            code: otp,
        }

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(details),
            })

            const data = await response.json()

            if (response.ok) {
                dispatchAuth({ type: 'token', payload: data.access_token })

                toast.success('OTP verified successfully!', {
                    position: 'top-center',
                })
                setTimeout(() => {
                    navigate('/reset-password')
                }, 1000)
            } else {
                toast.error(data?.message || 'Invalid OTP. Please try again.', {
                    position: 'top-center',
                })
            }
        } catch (error) {
            console.error('Error verifying OTP:', error)
            toast.error('Failed to verify OTP. Please try again.', {
                position: 'top-center',
            })
        }
    }

    const handleResendOtp = () => {
        setIsOtpSent(false)
        setOtp('')
        setTimer(300)
        sendOtp()
    }

    useEffect(() => {
        if (stateAuth.auth) {
            navigate('/reset-password')
        }
    }, [navigate, stateAuth])

    return (
        <div className={classes.wrapper}>
            <a href="/">
                <img src={logo} alt="BizTrade Logo" />
            </a>
            <div className={classes.box}>
                <div>
                    <img src={img} alt="Forgot Password Illustration" />
                </div>
                <div>
                    <h3>
                        Forgot
                        <br />
                        Password?
                    </h3>
                    <p>
                        Enter the email address associated with your account! <span>*</span>
                    </p>

                    <form onSubmit={handleSubmit}>
                        <label htmlFor="email">
                            <MdEmail />
                        </label>
                        <input
                            placeholder="Enter your email address"
                            type="email"
                            name="email"
                            id="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            disabled={isOtpSent}
                        />
                        <button type="submit" disabled={isOtpSent}>
                            Next
                        </button>
                    </form>

                    {isOtpSent && (
                        <div className={classes.show}>
                            <span>OTP has been sent to your email!</span>
                            <p className={classes.time}>
                                <span>{formatTime(timer)}</span>
                            </p>
                            {timer === 0 && (
                                <p className={classes.expired}>
                                    OTP expired.{' '}
                                    <button onClick={handleResendOtp} className={classes.resendBtn}>
                                        Resend OTP
                                    </button>
                                </p>
                            )}
                            {timer > 0 && (
                                <>
                                    <p>One Time Password (OTP)</p>
                                    <form onSubmit={handleOtpSubmit}>
                                        <div>
                                            <input
                                                type="text"
                                                name="otp"
                                                maxLength={6}
                                                placeholder="Enter OTP"
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <button type="submit">Confirm OTP</button>
                                    </form>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword
